export const topSheetColumns = [
    {
        field: "custom_id",
        name: "ID",
        align: "left",
        minWidth: 0,
        isTotalField: true,
    },
    {
        field: "name",
        name: "Item",
        align: "left",
        minWidth: 6,
        isTotalField: true,
    },
    {
        field: "external_notes",
        name: "Notes",
        align: "left",
        minWidth: 4.5,
        isTotalField: false,
    },
    {
        field: "is_internal",
        name: "Resource",
        align: "left",
        minWidth: 3,
        isTotalField: false,
    },
    {
        field: "vendor_currency",
        name: "Currency",
        align: "left",
        isTotalField: false,
    },
    {
        field: "vendor_rate",
        name: "Rate",
        align: "right",
        minWidth: 4.5,
        isTotalField: false,
    },
    {
        field: "rate_type",
        name: "Rate Type",
        align: "left",
        minWidth: 3.5,
        isTotalField: false,
    },
    {
        field: "client_rate",
        name: "Cost",
        align: "right",
        isTotalField: false,
    },
    {
        field: "budget_buffer",
        name: "Budget Buffer %",
        align: "right",
        isTotalField: false,
    },
    {
        field: "budget_buffer_amount",
        name: "Budget Buffer $",
        align: "right",
        isTotalField: false,
    },
    {
        field: "client_rate_budget_buffered",
        name: "Budgeted Rate",
        align: "right",
        isTotalField: false,
    },
    {
        field: "markup",
        name: "Markup %",
        align: "right",
        minWidth: 3.5,
        isTotalField: false,
    },
    {
        field: "markup_amount",
        name: "Markup $",
        align: "right",
        isTotalField: false,
    },
    {
        field: "client_rate_quoted",
        name: "Quoted Rate",
        align: "right",
        isTotalField: false,
    },
    {
        field: "days",
        name: "Units",
        align: "right",
        minWidth: 3,
        isTotalField: false,
    },
    {
        field: "quantity",
        name: "Qty",
        align: "right",
        minWidth: 3,
        isTotalField: false,
    },
    {
        field: "ot_1_5",
        name: "OT @ 1.5",
        align: "right",
        minWidth: 3.5,
        isTotalField: false,
    },
    {
        field: "ot_2_0",
        name: "OT @ 2.0",
        align: "right",
        minWidth: 3.5,
        isTotalField: false,
    },
    {
        field: "adjustment",
        name: "Adjustment",
        align: "right",
        minWidth: 1,
        isTotalField: false,
    },
    {
        field: "client_budget_buffered",
        name: "Budget Total",
        align: "right",
        isTotalField: false,
    },
    {
        field: "client_quoted",
        name: "Quoted Total",
        align: "right",
        isTotalField: true,
    },
];

/**
 * Returns topSheetColumns with dynamic sub-quantity columns inserted before "quantity".
 * @param {object} bid - The bid object containing sub_quantity_columns
 */
export function getTopSheetColumns(bid) {
    const subQtyCols = (bid?.sub_quantity_columns || []).map((col) => ({
        field: `sub_quantities.${col.id}`,
        name: col.name,
        align: "right",
        minWidth: 3,
        isTotalField: false,
    }));

    if (subQtyCols.length === 0) {
        return topSheetColumns;
    }

    const qtyIndex = topSheetColumns.findIndex((c) => c.field === "quantity");
    const result = [...topSheetColumns];
    // Rename "Qty" to "Total Qty" when sub-quantity columns exist
    result[qtyIndex] = { ...result[qtyIndex], name: "Total Qty" };
    result.splice(qtyIndex, 0, ...subQtyCols);
    return result;
}
